export const environment = {
    production: false,
    label: 'dev',
    API_GATEWAY_URL: 'https://dev-api.bciti.info',
};
